import { castArray } from 'lodash/fp'

import { getWithFallback } from '@masterplandev/utils'

import { ErrorPayloadWithMessage } from '../../types/ErrorPayloadWithMessage'

/*
 * Gets the first message found in an axios response coming from the backend.
 */
export default function getErrorMessage(
  failureResponse: ErrorPayloadWithMessage,
): string | Record<string, any> {
  const messages = getWithFallback(
    [
      'error.response.data.message',
      'error.response.data.messages',
      'error.data',
      'error.message',
      'response.data.message',
      'response.data.messages',
      'message',
      'error',
    ],
    failureResponse,
  )

  if (messages) {
    const message = castArray(messages)[0]
    if (typeof message === 'object' || typeof message === 'string') {
      return message
    }
  }

  return ''
}
